import React, { Component, Fragment } from 'react';
import { SessionConsumer } from '../../ui/components/SessionProvider';
import { withStyles } from '@material-ui/core/styles';
import { Edit, Restore, TransferWithinAStation } from '@material-ui/icons';
import { PaginatedDynamicDataTable, Button } from 'sm-react-components';
import PageContainer from '../container/PageContainer';
import * as requests from '../../infrastructure/requests';
import { setStorage, removeStorage } from '../../infrastructure/storageService';
import * as formatters from '../formatters';
import { Typography } from '@material-ui/core';

import { User as UserModal } from '../modals';

const styles = {
    noLogs: {
        padding: '10px'
    }
};

const DAYS = 30;

class Users extends Component {
  state = {
      userDetails: undefined,
      days: DAYS,
      active: true,
      openuserModal: false
  };

  viewUserDetails = userId => {
      this.setState({ userDetails: userId, openuserModal: true });
  };

  restoreUser = async userId => {
      await requests.restoreUser(userId);
      window.location.reload();
  };
  closeUserDetails = () => {
      this.setState({ openuserModal: false });
  };

  logAsUser = userId => {
      setStorage('as_user', userId);
      removeStorage('requestSelected');
      window.location.replace('/');
  };

  render() {
      const { userDetails, days, active, openuserModal } = this.state;
      const { classes } = this.props;

      return (
          <Fragment>
              <SessionConsumer>
                  {({ user }) => {
                      const isRoot = user.roles.includes('root');
                      return (
                          <PageContainer>
                              <UserModal
                                  open={openuserModal}
                                  userId={userDetails}
                                  onClose={this.closeUserDetails}
                                  rootUser={user}
                              />
                              <PaginatedDynamicDataTable
                                  key={days + active} //key is set becouse we want to rerender table when days changed
                                  provider={(offset, limit, sort, text) =>
                                      user.roles.includes('root')
                                          ? requests.getUsersWithStats(
                                              text,
                                              offset,
                                              limit,
                                              sort ? sort : 'created:desc',
                                              days,
                                              !active
                                          )
                                          : requests.getUsers(text, offset, limit, sort, !active)
                                  }
                                  mapping={[
                                      {
                                          column: 'active',
                                          //name: formatters.booleanLockIcon(true),
                                          formatter: active => formatters.booleanLockIcon(!active),
                                          align: 'right',
                                          style: {
                                              paddingLeft: '8px',
                                              paddingRight: '8px',
                                              width: '32px'
                                          }
                                      },
                                      {
                                          column: 'firstName',
                                          name: 'Name',
                                          sortable: true,
                                          computed: doc => ({
                                              name: `${doc.firstName ? doc.firstName : ''} ${
                                                  doc.lastName ? doc.lastName : ''
                                              }`,
                                              deleted: doc.deleted
                                          }),
                                          formatter: doc => (
                                              <div
                                                  style={
                                                      doc.deleted
                                                          ? { textDecoration: 'line-through' }
                                                          : {}
                                                  }
                                              >
                                                  {doc.name}
                                              </div>
                                          )
                                      },
                                      { column: 'company', name: 'Company', sortable: true },
                                      { column: 'email', name: 'Email', sortable: true },
                                      {
                                          column: 'roles',
                                          name: 'Roles',
                                          formatter: formatters.list
                                      },
                                      {
                                          column: 'created',
                                          name: 'Created',
                                          formatter: formatters.date,
                                          sortable: true
                                      },
                                      ...(isRoot
                                          ? [{ column: 'stats', name: 'Requests', align: 'center' }]
                                          : []),
                                      {
                                          computed: doc => doc,
                                          column: 'id',
                                          name: '',
                                          formatter: doc => (
                                              <Fragment>
                                                  {doc.deleted ? (
                                                      <Button
                                                          color="primary"
                                                          onClick={e => {
                                                              e.stopPropagation();
                                                              this.restoreUser(doc.id);
                                                          }}
                                                      >
                                                          <Restore />
                                                      </Button>
                                                  ) : (
                                                      <Button
                                                          color="secondary"
                                                          onClick={() => this.viewUserDetails(doc.id)}
                                                      >
                                                          <Edit />
                                                      </Button>
                                                  )}

                                                  {!doc.deleted &&
                            user.id !== doc.id &&
                            isRoot &&
                            !doc.roles.includes('root') && (
                                                      <Button
                                                          color="secondary"
                                                          onClick={e => {
                                                              e.stopPropagation();
                                                              this.logAsUser(doc.id);
                                                          }}
                                                          style={{ marginLeft: '8px' }}
                                                      >
                                                          <TransferWithinAStation />
                                                      </Button>
                                                  )}
                                              </Fragment>
                                          ),
                                          style: { width: '170px' }
                                      }
                                  ]}
                                  empty={
                                      <Typography className={classes.noLogs} variant="subtitle1">
                      No users found.
                                      </Typography>
                                  }
                                  multiSelectId={'id'}
                                  tableActions={[
                                      ...(isRoot
                                          ? [
                                              {
                                                  label: 'Active',
                                                  actionCallback: () => {
                                                      this.setState({ active: true });
                                                  },
                                                  styles: {
                                                      variant: active ? 'contained' : undefined
                                                  }
                                              },
                                              {
                                                  label: 'All',
                                                  actionCallback: () => {
                                                      this.setState({ active: false });
                                                  },
                                                  styles: {
                                                      variant: !active ? 'contained' : undefined
                                                  }
                                              },
                                              { spacer: true },
                                              {
                                                  label: '1 days',
                                                  actionCallback: () => {
                                                      this.setState({ days: 1 });
                                                  },
                                                  styles: {
                                                      variant: days === 1 ? 'contained' : undefined
                                                  }
                                              },
                                              {
                                                  label: '7 days',
                                                  actionCallback: () => {
                                                      this.setState({ days: 7 });
                                                  },
                                                  styles: {
                                                      variant: days === 7 ? 'contained' : undefined
                                                  }
                                              },
                                              {
                                                  label: '30 days',
                                                  actionCallback: () => {
                                                      this.setState({ days: 30 });
                                                  },
                                                  styles: {
                                                      variant: days === 30 ? 'contained' : undefined
                                                  }
                                              }
                                          ]
                                          : [])
                                  ]}
                                  tableSelectionActions={[
                                      {
                                          label: 'Edit',
                                          isEnabled: 'one',
                                          actionCallback: val => this.viewUserDetails(val[0].id)
                                      }
                                  ]}
                                  title="Users"
                                  search
                              />
                          </PageContainer>
                      );
                  }}
              </SessionConsumer>
          </Fragment>
      );
  }
}

export default withStyles(styles)(Users);
